import { render } from "./SendSMS.vue?vue&type=template&id=a7dd9b04&scoped=true"
import script from "./SendSMS.vue?vue&type=script&lang=js"
export * from "./SendSMS.vue?vue&type=script&lang=js"

import "./SendSMS.vue?vue&type=style&index=0&id=a7dd9b04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7dd9b04"]])

export default __exports__